import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "titlePages ma-0" }

import { ref, Ref, onMounted, onUnmounted, computed }      from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTAPIS  from '@/constants/apis'
import { MONITOREO } from '@/constants/monitoring'

/********************************
 ********** COMPONENTS **********
 *******************************/
import { VueDraggableNext } from 'vue-draggable-next';
import Prog_circular     from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALLHEADERFIX,HEADERFIX, DEFAULT_ITEMS } from '@/interfaces/SmartLink/Tables';
import { MONITORING } from '@/interfaces/GestorHCGLINK/Equips';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { getInfoByIP } from '@/functions/project';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonitoringView',
  setup(__props) {

const { t } = useI18n();

/********************************
 *********** FUNCTION ***********
 *******************************/
const sortKey = ref('')
const sortDesc = ref(false)

function sortBy(key: string) {
  if (sortKey.value === key) {
    sortDesc.value = !sortDesc.value
  } else {
    sortKey.value = key
    sortDesc.value = false
  }
}

// Lista ordenada computada
const sortedItems = computed(() => {
  if (!sortKey.value) return arrayOfObjects.value

  return [...arrayOfObjects.value].sort((a, b) => {
    const aVal = a[sortKey.value]
    const bVal = b[sortKey.value]

    if (aVal == null) return 1
    if (bVal == null) return -1

    if (aVal === bVal) return 0
    if (sortDesc.value) {
      return aVal < bVal ? 1 : -1
    } else {
      return aVal > bVal ? 1 : -1
    }
  })
})

const postURL = (item: any) => {
    window.open(`http://${item.ip}/webfig/#interfaces`, "_blank", "noopener,noreferrer");
}



const HEADERS:Ref<ALLHEADERFIX> = ref({
    principal : [            
        {title : 'status',           key: 'status',            sortable:true},
        // {title : 'name',             key: 'fName',             sortable:true},
        {title : 'name',             key: 'name',              sortable:true},
        {title : 'ip',               key: 'ip',                sortable:true},
        {title : 'tipo',             key: 'tipo',              sortable:true},
        {title : 'imei',             key: 'imei',              sortable:true},
        {title : 'Primary Band',     key: 'primary-band',      sortable:true},
        {title : 'DL Modulation',    key: 'dl-modulation',     sortable:true},
        {title : 'CQI',              key: 'cqi',               sortable:true},
        {title : 'RI',               key: 'ri',                sortable:true},
        {title : 'MCS',              key: 'mcs',               sortable:true},
        {title : 'rssi (dBm)',       key: 'rssi',              sortable:true},
        {title : 'rsrp (dBm)',       key: 'rsrp',              sortable:true},
        {title : 'rsrq (dB)',        key: 'rsrq',              sortable:true},
        {title : 'sinr (dB)',        key: 'sinr',              sortable:true},
        {title : 'APN',              key: 'apn-profiles',      sortable:true},
        {title : 'network-mode',     key: 'network-mode',      sortable:true},
        {title : 'uptime',           key: 'session-uptime',    sortable:true},
        {title : 'enb-id',           key: 'enb-id',            sortable:true},
        {title : 'phy-cellid',       key: 'phy-cellid',        sortable:true},
    ],
    secundary: [
        {title : 'phy-cellid',       key: 'phy-cellid',        sortable:true},
    ]
})


const columnsList:Ref<string[]> = ref([])
const allColumnsList:Ref<string[]> = ref([])
const columnSelected = ref('');
const textColumn    = ref('');


const ALLHEADER:Ref<HEADERFIX[]> = ref(HEADERS.value.principal)

const changeHeader = (header:Array<HEADERFIX>) => {
    ALLHEADER.value = header;
    getAllColumnsList()
}

const itemsColumns = ref([
    { title: 'Agregar Columnas', value: 1, disabled:computed(() => columnsList.value.length == 0 ) },
    { title: 'Eliminar Columnas', value: 2, disabled:computed(() => allColumnsList.value.length == 0 )},
]);

const agregarColumna = () => {
    ALLHEADER.value.push({
        title       : textColumn.value??'Texto Default',
        key         : columnSelected.value,
        sortable    : true,
    })
    columnsList.value = columnsList.value.filter(item => item !== columnSelected.value); //Elimino item del array para no mostrarlo
    textColumn.value = '';
    columnSelected.value = '';
    getAllColumnsList();
}

const eliminarColumna = () => {
    ALLHEADER.value = ALLHEADER.value.filter((item:HEADERFIX) => item.key !== columnSelected.value); //elimino el elemento seleccionado
    columnsList.value.push(columnSelected.value);
    columnSelected.value = '';
    getAllColumnsList();
}

const dialog        = ref(false);
const dialogDelete  = ref(false);
const showDialog = (valor:number) => {
    if(valor === 1) dialog.value = true;
    if(valor === 2) dialogDelete.value = true;
}

let ws: WebSocket | null = null;
const finalObject = ref<MONITORING>({});
// const arrayOfObjects = ref<DEFAULT_ITEMS[]>([]);
const arrayOfObjects = ref<any[]>(MONITOREO);

const getAllColumnsList = () => {
    allColumnsList.value = []
    ALLHEADER.value.forEach((item:HEADERFIX) => {
        allColumnsList.value.push(item.key)
    })
}

/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : tipo
 * }
 * se Usa para colocar el tipo de los equipos en la tabla
 */
const finalTypeByIP:Ref<STRINGS> = ref(getInfoByIP('tipo'))
    
/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : name
 * }
 * se Usa para colocar el name de los equipos en la tabla
 */
const finalNameByIP:Ref<STRINGS> = ref(getInfoByIP('name'))

onMounted( async() => {
    getAllColumnsList();

    /**
     * LLama al websocket y recibe datos constatemente
     * Va almacenando en la variable arrayOfObjects
     */
    // ws = new WebSocket(`http://192.168.3.81/cloud/monitoreo/update`);
    // ws = new WebSocket(`${CONSTAPIS.APIS.value.webSocket.wss}`);

    // ws.onopen = () => console.log("Conectado al WebSocket");

    // ws.onmessage = (event) => {
    //     let finalData = JSON.parse(event.data);
    //     console.log(finalData)
    //     if(finalData.ip){
    //         if(!finalObject.value[finalData.ip]){
    //             finalObject.value[finalData.ip] = {}
    //         }
    //         finalObject.value[finalData.ip] = finalData;
            
    //         arrayOfObjects.value = Object.keys(finalObject.value).map(key => {
    //             return {
    //                 ip: key,
    //                 tipo: finalTypeByIP.value[key],
    //                 fName: finalNameByIP.value[key],
    //                 ...finalObject.value[key]
    //             };
    //         });
    //     }
    // };

    // ws.onerror = () => console.error("Habilitar la API: ", CONSTAPIS.APIS.value.webSocket.wss);

})
onUnmounted(() => {
    // if (ws) {
    //     ws.close(); // Cerrar la conexión WebSocket
    //     console.log('WebSocket cerrado al desmontar el componente');
    // }
});


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "bgtopology",
      class: "ma-4 defaultCard"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: "mb-4",
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('title.monitoring')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          justify: "start",
          class: "mb-5 mr-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_menu, { location: 'end' }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  icon: "mdi-menu",
                  variant: "plain"
                }), null, 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { nav: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsColumns.value, (item, i) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: i,
                        value: item.value,
                        title: item.title,
                        class: "nav_item_title",
                        disabled: item.disabled,
                        link: "",
                        onClick: ($event: any) => (showDialog(item.value))
                      }, null, 8, ["value", "title", "disabled", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (sortedItems.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_data_table, {
              key: 0,
              headers: ALLHEADER.value,
              items: sortedItems.value,
              "table-class-name": "customize-table",
              "hide-footer": sortedItems.value.length < 5
            }, {
              headers: _withCtx(() => [
                _createVNode(_unref(VueDraggableNext), {
                  class: "dragArea list-group w-full",
                  list: ALLHEADER.value,
                  tag: "tr",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (changeHeader(ALLHEADER.value)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ALLHEADER.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: item.key??i,
                        onClick: ($event: any) => (sortBy(item.key))
                      }, [
                        _createTextVNode(_toDisplayString(item.title?.toUpperCase()) + " ", 1),
                        (sortKey.value === item.key)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(sortDesc.value ? '🔽' : '🔼'), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_2))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list"])
              ]),
              item: _withCtx(({item}) => [
                _createElementVNode("tr", {
                  class: "monitoreoTR",
                  onClick: ($event: any) => (postURL(item))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ALLHEADER.value, (header, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item[`${header.key?? 'ip'}` ]), 1))
                  }), 128))
                ], 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["headers", "items", "hide-footer"]))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              justify: "center",
              class: "ma-4"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            })),
        _createVNode(_component_v_divider, {
          thickness: "5",
          color: "white",
          opacity: "1",
          class: "mt-4 mb-4"
        }),
        false
          ? (_openBlock(), _createBlock(_component_v_sheet, {
              key: 2,
              color: "transparent",
              class: "defaultCard ma-0 pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('labels.location')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  class: "ma-4",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, { width: "60%" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("div", { id: "map" }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
      width: "55%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "card_dialog pa-4",
          color: "background"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0 py-2",
                  cols: "12",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("span", { class: "subtitleDashboard" }, " Agregar Columna", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0 py-2 pr-2",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "hide-details": "",
                      density: "compact",
                      variant: "outlined",
                      modelValue: textColumn.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textColumn).value = $event)),
                      label: "Nombre Columna"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0 py-2 pl-2",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      "hide-details": "",
                      density: "compact",
                      variant: "outlined",
                      modelValue: columnSelected.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((columnSelected).value = $event)),
                      items: columnsList.value,
                      label: "Valor Columna"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  block: "",
                  color: "success",
                  onClick: agregarColumna,
                  disabled: textColumn.value === '' || columnSelected.value === ''
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Agregar", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialogDelete.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogDelete).value = $event)),
      width: "55%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "card_dialog pa-4",
          color: "background"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0 py-2",
                  cols: "12",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("span", { class: "subtitleDashboard" }, " Eliminar Columna", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0 py-2 pl-2",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      "hide-details": "",
                      density: "compact",
                      variant: "outlined",
                      modelValue: columnSelected.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((columnSelected).value = $event)),
                      items: allColumnsList.value,
                      label: "Valor Columna"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  block: "",
                  color: "success",
                  onClick: eliminarColumna,
                  disabled: columnSelected.value === ''
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Eliminar", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})